import { logError } from '@zg-rentals/log-error';
import { RentalManagerUserPropertyDetailsWebApiHandler_details } from '@zg-rentals/ts-rental-manager-api-client';
import { useRentalManagerUserPropertyCreateV2WebApiHandler_create } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { LISTING_TYPE_TO_ENUM, PROPERTY_TYPE_TO_ENUM } from '../constants';

import type { ListingTypeLabel } from '../constants';

export type CreatePropertyFormData = {
  listingType: ListingTypeLabel;
  propertyType: string;
  fullAddress: string;
  unitNumber?: string;
  numUnits?: string;
  customerId?: string | null;
};

const useCreateProperty = () => {
  const { mutateAsync } = useRentalManagerUserPropertyCreateV2WebApiHandler_create({
    meta: {
      context: {
        api: 'rental-manager',
        details: 'Creating property',
      },
    },
  });

  const createProperty = async (formData: CreatePropertyFormData) => {
    try {
      const result = await mutateAsync({
        postData: {
          listingType: LISTING_TYPE_TO_ENUM[formData.listingType],
          propertyType: PROPERTY_TYPE_TO_ENUM[formData.propertyType],
          fullAddress: formData.fullAddress,
          ...(formData.unitNumber != null && { unitNumber: formData.unitNumber }),
          ...(formData.numUnits != null && { numUnits: Number(formData.numUnits) }),
          ...(formData.customerId != null && { customerId: formData.customerId }),
          includeWebAnalytics: true,
        },
      });

      // Fetch full property details to maintain parity with the old PostingActions.property.create
      const propertyDetails = await RentalManagerUserPropertyDetailsWebApiHandler_details({
        listingAlias: result.listingAlias,
      });

      return propertyDetails;
    } catch (error) {
      logError({
        error,
        context: 'useCreateProperty',
      });

      throw error;
    }
  };

  return { createProperty };
};

export { useCreateProperty };
